import React from 'react';
import { SelfSortingTasksList } from 'shared/components/ui/tasks-list';

import { TaskSectionLayout } from './task-section-layout';

export type SelfSortingTaskSectionProps = Omit<
  React.ComponentProps<typeof TaskSectionLayout>,
  'children'
> &
  React.ComponentProps<typeof SelfSortingTasksList>;

export const SelfSortingTaskSection: React.FC<SelfSortingTaskSectionProps> = ({
  tasks,
  selectedTask,
  hasOwnSelectedState,
  showRepeatingAsTodo,
  showRepeatingAsDoneOnDateEntry,
  hideGoal,
  hideMeta,
  hideLifeArea,
  showDetailOnSelect,
  displayDue,
  onReorder,
  isMoving,

  customHeader,
  date,
  goalId,
  lifeAreaId,
  priority,
  tagIds,
  headerToDisplay,
  headerIsLink,
  goals,
  lifeAreas,
  headerHasImage,
  canCreateTask,
  canCreateHabit,
  canCollapse,
  newTaskInputRef,
  onPremium,
}) => (
  <TaskSectionLayout
    customHeader={customHeader}
    date={date}
    goalId={goalId}
    lifeAreaId={lifeAreaId}
    priority={priority}
    tagIds={tagIds}
    headerToDisplay={headerToDisplay}
    headerIsLink={headerIsLink}
    goals={goals}
    lifeAreas={lifeAreas}
    headerHasImage={headerHasImage}
    canCreateTask={canCreateTask}
    canCreateHabit={canCreateHabit}
    canCollapse={canCollapse}
    newTaskInputRef={newTaskInputRef}
    onPremium={onPremium}
    hideMeta={hideMeta}
  >
    <SelfSortingTasksList
      tasks={tasks}
      selectedTask={selectedTask}
      hasOwnSelectedState={hasOwnSelectedState}
      showRepeatingAsTodo={showRepeatingAsTodo}
      showRepeatingAsDoneOnDateEntry={showRepeatingAsDoneOnDateEntry}
      hideGoal={hideGoal}
      hideLifeArea={hideLifeArea}
      showDetailOnSelect={showDetailOnSelect}
      displayDue={displayDue}
      onReorder={onReorder}
      isMoving={isMoving}
    />
  </TaskSectionLayout>
);
